// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {AutomationActionCell} from './AutomationActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {UserJoinedDate} from './UserJoinedCell'
import {User} from '../../core/_models'
import { UserStatuCell } from './UserStatusCell'

const usersColumns: ReadonlyArray<Column<User>> = [
  
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: 'selection',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index]._id} />,
  // },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Keyword' className='min-w-125px' />,
    id: 'keyword',
    Cell: ({...props}) => <UserInfoCell automation={props.data[props.row.index]} />,
  },
  
 
  
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <AutomationActionCell id={props.data[props.row.index].id} status={props.data[props.row.index].status} 
    automation={props.data[props.row.index]}
    />,
  },
]

export {usersColumns}
